import {
  doc,
  getDoc,
  updateDoc,
  setDoc,
  arrayUnion,
  increment
} from 'firebase/firestore'
import firebase from '../../firebase'

const addTagToSession = async (tag, sessionId, sessionDate, sessionMovement, userId) => {
  const sessionRef = doc(firebase.db, 'sessions', sessionId)
  const tagRef = doc(firebase.db, 'sessionTags', tag)

  // Append to the tags array for the session
  await updateDoc(sessionRef, {
    tags: arrayUnion(tag)
  })

  // Update sessionTags collection
  const tagDoc = await getDoc(tagRef)

  if (tagDoc.exists()) {
    // If the tag document exists, increment sessionsCount and update the sessions map
    await updateDoc(tagRef, {
      sessionsCount: increment(1),
      [`sessions.${sessionId}`]: {
        date: sessionDate,
        movement: sessionMovement,
        userId: userId
      }
    })
  } else {
    await setDoc(tagRef, {
      sessionsCount: 1,
      sessions: {
        [sessionId]: {
          date: sessionDate,
          movement: sessionMovement,
          userId: userId
        }
      }
    })
  }
}

export default addTagToSession
